var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8509 0.15002C2.92164 0.120684 2.99921 0.104492 3.08057 0.104492C3.16192 0.104492 3.23949 0.120684 3.31024 0.15002C3.381 0.1793 3.4473 0.222702 3.50483 0.280228L5.90483 2.68023C6.13915 2.91454 6.13915 3.29444 5.90483 3.52876C5.67052 3.76307 5.29062 3.76307 5.0563 3.52876L3.68057 2.15302L3.68057 5.50449C3.68057 5.83586 3.41194 6.10449 3.08057 6.10449C2.7492 6.10449 2.48057 5.83586 2.48057 5.50449L2.48057 2.15302L1.10483 3.52876C0.870516 3.76307 0.490617 3.76307 0.256303 3.52876C0.0219882 3.29444 0.0219882 2.91454 0.256303 2.68023L2.6563 0.280228C2.71383 0.222703 2.78013 0.1793 2.8509 0.15002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.ca759833337d95d5325653add40131d4.svg";
export { ForwardRef as ReactComponent };